import { Text } from "@mantine/core";
import { currencyFormat } from "../../../utils";
import classes from "./ReportShell.module.css";

/** «1,155,240.00» — ₮ тэмдэггүй. */
export const money = (v: number | string | null | undefined) => currencyFormat(Number(v || 0)).replace(/\s*₮$/, "");

/** Тоон нүд: 0 / null → саарал «—»; `signed` бол сөрөг нь улаан. */
export const Amt = ({
  value,
  strong,
  signed,
}: {
  value: number | string | null | undefined;
  strong?: boolean;
  signed?: boolean;
}) => {
  const n = Number(value ?? 0);
  if (!n) return <Text span className={classes.muted}>-</Text>;
  const cls = [signed && n < 0 ? classes.negative : "", strong ? classes.strong : ""].filter(Boolean).join(" ");
  return <Text span className={cls || undefined}>{signed && n < 0 ? `−${money(Math.abs(n))}` : money(n)}</Text>;
};
